/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/tg': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm4.822-23.176c-1.527.635-8.748 3.634-14.384 6.113-1.467.646-1.826 1.318-.315 1.837l.116.04c.452.155 1.374.474 2.317.745 1.366.392 2.534.14 3.326-.399.137-.093.492-.348.994-.709 1.42-1.022 4.021-2.892 6.217-4.348.207-.137.444.097.282.29-1.308 1.247-2.95 2.783-4.16 3.915a193.85 193.85 0 00-1.63 1.534c-1.048 1.025-.135 1.613.586 2.078.113.073.222.143.318.211.768.55 4.309 2.892 5.01 3.355 1.46.962 2.387.698 2.8-1.526.485-2.608 1.055-6.316 1.46-8.945.177-1.153.322-2.098.415-2.653.421-2.532-.425-2.751-3.183-1.608l-.169.07z" _fill="#0B2C62"/>'
  }
})
